console.log("▶️ bygge-slider.js geladen");

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".iwtx-slider");
  console.log("Gefundene Slider:", sliders.length);

  sliders.forEach((slider, sIndex) => {
    const sliderId = slider.id || `slider-${sIndex}`;
    const track = slider.querySelector(".iwtx-track");
    const slides = slider.querySelectorAll(".iwtx-slide");
    const dots = slider.querySelectorAll(".iwtx-dot");

    // Wenn weniger als 2 Slides → keine Logik ausführen
    if (!track || slides.length < 2) {
      console.log(`ℹ️ ${sliderId}: nur ${slides.length} Slide(s) → kein Autoplay`);
      return;
    }

    const interval = parseInt(slider.dataset.interval, 10) || 3000;
    const direction = slider.dataset.direction || "left";
    let index = 0;
    let timer;

    function showSlide(i) {
      index = i;
      const offset = -index * 100;
      track.style.transform = `translateX(${offset}%)`;
      dots.forEach((dot, di) =>
        dot.setAttribute("aria-current", di === index ? "true" : "false")
      );
      console.log(`▶️ ${sliderId}: Slide ${index} angezeigt`);
    }

    function nextSlide() {
      index = (index + 1) % slides.length;
      showSlide(index);
    }

    function prevSlide() {
      index = (index - 1 + slides.length) % slides.length;
      showSlide(index);
    }

    function tick() {
      if (direction === "left") {
        nextSlide();
      } else {
        prevSlide();
      }
    }

    function start() {
      stop();
      timer = setInterval(tick, interval);
      console.log(
        `▶️ ${sliderId}: Autoplay gestartet (alle ${interval}ms, Richtung: ${direction})`
      );
    }

    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
      console.log(`⏸️ ${sliderId}: Autoplay gestoppt`);
    }

    // Init
    showSlide(0);
    start();

    // Pause bei Hover
    slider.addEventListener("mouseenter", stop);
    slider.addEventListener("mouseleave", start);

    // Swipe für Mobile
    let startX = 0;
    slider.addEventListener("touchstart", (e) => {
      startX = e.touches[0].clientX;
    });
    slider.addEventListener("touchend", (e) => {
      const endX = e.changedTouches[0].clientX;
      if (endX - startX > 50) {
        prevSlide();
      } else if (startX - endX > 50) {
        nextSlide();
      }
    });
  });
});
